import { useContext, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'

import WaveLoading from 'components/WaveLoading'
import Divider from '../Divider'
import InputField from '../InputField'

import AuthorizeButton from './AuthorizeButton'
import './GooglePlayBucket.scss'
import useGetUniqueAccount from 'containers/services/useGetUniqueAccount'
import OrganizationsContext from 'containers/organizations/organizationsContext'
import useApiCreds from 'containers/services/useApiCreds'

const Guide = ({ onHide, show }) => {
  return (
    <div className={`guide ${show ? 'show' : ''}`}>
      <button onClick={() => onHide()} className="close-button">
        &times;
      </button>
      <h1>Setup Guide</h1>
      <Divider spaceY={10} />
      <div className="step-heading">
        <p>Step 1</p>
        <h2>Get your Private API Key</h2>
      </div>
      <ol>
        <li>Log in to <a href="https://www.klaviyo.com/login" target="_blank" rel="noreferrer">your Klaviyo account</a>.</li>
        <li>Click <b>Settings</b> (gear icon) in the lower-left corner.</li>
        <li>Navigate to <b>Account &gt; Settings &gt; API keys</b>.</li>
        <li>Click <b>Create Private API Key</b>.</li>
        <li>Give it a name (e.g. "Maya Insights") and select <b>Read-only</b> access.</li>
        <li>Copy the generated private API key (it starts with <b>pk_</b>).</li>
      </ol>
    </div>
  )
}

const Klaviyo = () => {
  const [showGuide, setShowGuide] = useState(true)
  const [apiKey, setApiKey] = useState("")
  const { currentOrganization } = useContext(OrganizationsContext)
  const history = useHistory()
  const serviceUUID = useParams<{id: string}>().id
  const {saveApiCreds, saveCredsError} = useApiCreds(serviceUUID)

  const saveData = async () => {
    if (apiKey) {
        localStorage.setItem('redirectServiceUuid', serviceUUID)
        try {
          await saveApiCreds(currentOrganization.id, {apiKey: apiKey})
          history.push(`/organization/${currentOrganization.slug}/sources`)
        } catch {
          // error is displayed via saveCredsError
        }
      }
  }

  return (
    <div className="guide-container">
      <Guide onHide={() => setShowGuide(false)} show={showGuide} />

      <img
        src="https://old.mayainsights.com/static/img/logos/klaviyo.svg"
        width="200"
        alt=""
      />
      <p>
        Press the{' '}
        <button style={{verticalAlign: "initial"}} className="button-tip" onClick={() => setShowGuide(true)}>
          Guide
        </button>{' '}
        button to help you through the configuration process.
      </p>
      <div style={{ display: 'flex', flexDirection: "column", alignItems: 'flex-start', gap: '1rem', width: "50%"}}>
      <Divider spaceY={10}></Divider>
      <h2 style={{fontWeight: "normal"}}>Configure Klaviyo</h2>
      <p style={{ color: "#9b9b9b", fontSize: "14px", margin: "0 "}}>Provide the Private API Key from your Klaviyo account settings</p>
      <div style={{display: "flex", alignItems: 'center', gap: "2rem"}}>
        <div style={{display: "flex", flexDirection: "column", width: "150%"}}>
          <InputField
            label="Private API Key"
            initialValue=''
            type='string'
            value={apiKey}
            setValue={setApiKey}
          />
        </div>
        <button style={{margin: 0 }} className="submit-button" disabled={!apiKey} onClick={saveData}>Save</button>
      </div>
      {saveCredsError && <p style={{ color: 'red', fontSize: '14px' }}>{saveCredsError}</p>}
      </div>

      <div className="guide-bar">
        <button
          className="submit-button guide-button"
          onClick={() => setShowGuide(true)}
        >
          <span>Guide</span>
          <span className="material-icons-outlined saved-icon non-selectable">
            menu_book
          </span>
        </button>
      </div>
    </div>
  )
}

export default Klaviyo
